/* eslint-disable max-classes-per-file */
import FundKPIs from "../../pages/assetmanagement/templates/FundKPIs"
import DocTemplate from "./DocTemplate"

export class Template {
  constructor(Component, defaultProps) {
    this.component = Component
    this.defaultProps = defaultProps
  }

  static of(Component, defaultProps = {}) {
    return new Template(Component, defaultProps)
  }
}

/**
 * Really basic registry that keep all known template from Application.
 * A template can be display via route: /widget/template/${alisWidgetName}?name=${templateName}
 * Example: /widget/template/funds?name=fund_summary
 */
class TemplateRegistry {
  constructor() {
    this.template = {}
  }

  /**
   * Get template by its name.
   * @param name
   * @returns {*}
   */
  get(name) {
    if (name === undefined || name === null) {
      throw new Error(
        "Illegal argument exception. Template name can't be null or undefined"
      )
    }

    const template = this.template[name]
    if (template === undefined || template === null) {
      const allTmpl = this.availableTemplate()
      const allTmplStr = allTmpl.join(", ")
      throw new Error(
        `Template ${name} not found. Available templates are: ${allTmplStr}`
      )
    }
    return template
  }

  /**
   * Register a template with default props
   * @param name
   * @param template
   */
  registerTemplate(name, template) {
    if (name === undefined || name === null) {
      throw new Error(
        "Illegal argument exception. Template name can't be null or undefined"
      )
    }
    if (template.component === undefined || template.component === null) {
      throw new Error(
        "Illegal argument exception. Template Component can't be null or undefined"
      )
    }
    this.template[name] = template
  }

  availableTemplate() {
    return Object.keys(this.template)
  }
}

// Register all Widgets here
const fundKpisTmpl = Template.of(FundKPIs, {
  transformer: "fund_kpis_model_transformation"
})
const docTemplate = Template.of(DocTemplate)

const templateManager = new TemplateRegistry()
templateManager.registerTemplate("fund_kpis", fundKpisTmpl)
// just snippet code for webportal-documentation project
// if you modify code below make sure you'll update documentation project
templateManager.registerTemplate("doc_hello_world", docTemplate)

export default templateManager
